import { Typography, Card, CardContent, Stack, Box } from '@mui/material';

function ProfileSection({ title, action, children }) {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)' }}>
      <CardContent sx={{ p: { xs: 2.5, sm: 3.5 } }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start', justifyContent: 'space-between', mb: 2 }}>
          <Stack direction="row" spacing={1.5} sx={{ alignItems: 'flex-start', minWidth: 0 }}>
            <Box sx={{ width: 4, height: 20, borderRadius: 2, bgcolor: 'primary.main' }} />
            <Typography variant="h6" sx={{ overflowWrap: 'anywhere' }}>{title}</Typography>
          </Stack>
          {action}
        </Stack>
        {children}
      </CardContent>
    </Card>
  );
}

export default ProfileSection;
